import { DateFormat } from '@celito.clients/enums';
import { Icon } from '@celito.clients/shared';
import { formatDate } from '@celito.clients/utils';
import {
  Card,
  CardFooter,
  CardHeader,
  Menu,
  MenuItem,
  MenuList,
  MenuPopover,
  MenuTrigger,
  ToolbarButton,
} from '@fluentui/react-components';

import { ResultCardProps } from '../search-result.model';
import classes from '../search-result.module.css';

// Ordered list of columnKeys to show in the card body.
// Adjust keys to match the actual API response if needed.
const CARD_BODY_FIELD_KEYS = ['owner', 'ownedBy', 'status'];

const ResultCard = (props: ResultCardProps) => {
  const { result } = props;

  // Always render Title | ID, and append Version when present (CD records)
  const cardHeaderParts = [
    result.resultTitle,
    result.resultLabel,
    result.version,
  ].filter(Boolean);
  const cardHeaderText = cardHeaderParts.join(' | ');

  // Filter body to only Owner and Status fields
  const bodyFields = CARD_BODY_FIELD_KEYS.map(
    (key) => result.cardBodyContent[key]
  ).filter(Boolean);

  return (
    <Card className={classes.card} appearance="subtle">
      <CardHeader
        header={
          <div
            className={classes.card_header}
            role="button"
            onClick={() => {
              props.onViewSearchDoc(
                result.detailViewName ?? '',
                result.resultName ?? result.resultLabel ?? '',
                result.version ?? '',
                result.resultLabel ?? '',
                result.resultTitle ?? '',
                result.moduleName ?? ''
              );
            }}
          >
            {cardHeaderText}
          </div>
        }
        description={
          <div className={classes.card_description}>
            {result.objectType ?? result.moduleName}
          </div>
        }
        action={
          <Menu>
            <MenuTrigger>
              <ToolbarButton
                aria-label="More"
                icon={<Icon iconName="MoreHorizontal20Regular" />}
              />
            </MenuTrigger>

            <MenuPopover>
              <MenuList>
                <MenuItem
                  icon={<Icon iconName="Eye16Regular" />}
                  onClick={() => {
                    props.onViewSearchDoc(
                      result.detailViewName ?? '',
                      result.resultName ?? result.resultLabel ?? '',
                      result.version ?? '',
                      result.resultLabel ?? '',
                      result.resultTitle ?? ''
                    );
                  }}
                >
                  View
                </MenuItem>
              </MenuList>
            </MenuPopover>
          </Menu>
        }
      />

      <div className={classes.card_content}>
        {bodyFields.map((field) => (
          <p key={field.label}>
            {field.label}: {field.value}
          </p>
        ))}
      </div>

      <CardFooter className={classes.card_footer}>
        {result.modifiedAtDate &&
          formatDate(result.modifiedAtDate, DateFormat.Date)}
      </CardFooter>
    </Card>
  );
};

export default ResultCard;
